import { i18n } from "../../../plugins/i18n.js";
import locales from "../../../res/translations";

const stored = localStorage.getItem("language");
const locale = locales[stored ?? i18n.locale];

export default [
  {
    column: "U_businessTrip",
    selector: new RegExp(locale["yes"]),
    className: "green--text"
  },
  {
    column: "U_businessTrip",
    selector: new RegExp(locale["no"]),
    className: "red--text"
  },
  {
    column: "U_weekday",
    selector: new RegExp(`(${locale["saturday"]}|${locale["sunday"]})`),
    className: "red--text"
  },
  {
    column: "U_ratio",
    selector: /\d{3}(\.\d+)?/,
    className: "green--text"
  },
  {
    column: "U_ratio",
    selector: /\d{1,2}(\.\d+)?/,
    className: "red--text"
  },
  {
    column: "U_difference",
    selector: /^\d+:\d{2}$/,
    className: "green--text"
  },
  {
    column: "U_difference",
    selector: /^-\d+:\d{2}$/,
    className: "red--text"
  },
  {
    column: "U_ratio",
    selector: /^NaN/,
    cssStyle: "font-size: 0px"
  },
  {
    column: "U_debit",
    selector: /^\d+:\d{2}$/,
    className: "green--text"
  },
  {
    column: "U_debit",
    selector: /^-\d+:\d{2}$/,
    className: "red--text"
  }
];
